import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UnreadSnapshot } from '../../api/forum-unread'

type UnreadState = {
  scope: string
  userId?: number
  competenceId?: number
  revision: number
  counts: Record<number, number>
  questionTopicIds?: number[]
}

const initialState: UnreadState = { scope: '', revision: 0, counts: {} }
const createUnreadSlice = (name: string) =>
  createSlice({
    name,
    initialState,
    reducers: {
      activate: (_, { payload }: PayloadAction<{ scope: string; userId: number; competenceId: number }>) => ({
        ...initialState,
        ...payload,
      }),
      invalidate: (state) => {
        state.revision++
      },
      receive: (state, { payload }: PayloadAction<{ scope: string; revision: number; snapshot: UnreadSnapshot }>) => {
        if (
          state.scope !== payload.scope ||
          state.revision !== payload.revision ||
          state.competenceId !== payload.snapshot.competenceId
        )
          return
        state.counts = {}
        state.questionTopicIds = payload.snapshot.questionTopicIds || []
        payload.snapshot.topics.forEach(({ topicId, unreadCount }) => {
          state.counts[topicId] = unreadCount
        })
      },
      release: (state, { payload }: PayloadAction<string>) => (state.scope === payload ? initialState : state),
    },
    extraReducers: (builder) => {
      builder.addMatcher(
        (action) => ['clearUserData/pending', 'fetchLogOut/pending'].includes(action.type),
        () => initialState,
      )
    },
  })

const slice = createUnreadSlice('forumUnread')
const messagesSlice = createUnreadSlice('messagesUnread')
export const messagesUnreadActions = messagesSlice.actions
export const messagesUnreadReducer = messagesSlice.reducer
export const forumUnreadActions = slice.actions
export default slice.reducer
